import {
  find as _find,
  get as _get,
  set as _set,
  sumBy as _sumBy,
} from "lodash";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Button,
  NativeSelect,
  Input,
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import "./BrandAppendix.css";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import {
  selectedContract,
  payment_terms,
  brand_details,
} from "../../redux/contract/contract.selector";

import {
  postContractAppendix,
  submitAppendixForApproval,
  approveAppendix,
  rejectAppendix,
} from "../../helpers/services/ContractServices";

import { showSnackbar } from "../../redux/snackbar/snackbar.action";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(2),
  },
  section: {
    border: `2px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(1),
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
  },
  spanText: {
    ...theme.typography.subtitle1,
  },
  gridRoot: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {},
  img: {
    objectFit: "cover",
    objectPosition: "center",
    width: "100%",
    height: "100%",
  },
  buttonSection: {
    marginTop: "5%",
    width: "90%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  button: {
    fontSize: "0.75em",
    width: "40%",
    backgroundColor: "#1e453b",
    color: "#ffffff",

    "&:hover": {
      border: "1px solid #1e453b",
      backgroundColor: "#ffffff",
      color: "#1e453b",
    },
  },
  section3Text: {
    textIndent: "2%",
  },
}));

const BrandAppendix = ({
  selectedBrandAppendix,
  switchDataRefreshOn,
  selectedContract,
  payment_terms,
  brand_details,
  location,
  showSnackbar,
  user,
}) => {
  const { t } = useTranslation();
  // let brands = useRecoilValue(appBrandDetails);
  let brands = brand_details;
  // const [brands, setBrands] = React.useState(brand_details);
  const [appendixCategory, setAppendixCategory] = React.useState(
    selectedBrandAppendix.category || ""
  );
  const [discounts, setDiscounts] = React.useState(
    selectedBrandAppendix.discount
  );
  const [revenues, setRevenues] = React.useState(selectedBrandAppendix.revenue);
  const [showroomChairs, setShowroomChairs] = React.useState(
    _get(
      _find(brands, (b) => {
        return selectedBrandAppendix.brand_id === b.id;
      }),
      "basic_chair"
    ) || ""
  );
  const [specialTerms, setSpecialTerms] = React.useState(
    selectedBrandAppendix?.special_terms || ""
  );
  const [paymentDetails] = React.useState(payment_terms);

  const [paymentTerms, setPaymentTerms] = React.useState(
    selectedBrandAppendix.paymentterms_id_short_name || ""
  );
  const [baseDiscount, setBaseDiscount] = React.useState(
    selectedBrandAppendix.appendix_base_discount
  );
  const [approvalMessage, setApprovalMessage] = React.useState();
  const [isInputDisabled, setIsInputDisabled] = React.useState(true);
  const [validationResult, setValidationResult] = React.useState({});
  const classes = useStyles();
  console.log("selectedContract", selectedContract);
  console.log("selectedBrandAppendix", selectedBrandAppendix);
  console.log("brands", brands);
  console.log("PAYMENT", paymentDetails);

  React.useEffect(() => {
    let _isInputDisabled = true;
    // selectedContract.brands.map((brand) => {
    //   if (brand.teamlead_id == user.currentUser.id) {
    //     setIsBrandTeamLead(true);
    //   }
    //   if (brand.saleslead_id == user.currentUser.id) {
    //     setIsBrandSalesLead(true);
    //   }
    setAppendixCategory(selectedBrandAppendix.category);
    setDiscounts(selectedBrandAppendix.discount);
    setRevenues(selectedBrandAppendix.revenue);
    setSpecialTerms(selectedBrandAppendix.special_terms);
    if (
      _get(
        _find(selectedContract.brands, {
          brand_name: selectedBrandAppendix.brand_id_short_name,
        }),
        "saleslead_id"
      ) === user.currentUser.id &&
      (selectedBrandAppendix.status === "initial" ||
        selectedBrandAppendix.status === "rejected")
    ) {
      _isInputDisabled = false;
    } else {
      _isInputDisabled = true;
    }
    setIsInputDisabled(_isInputDisabled);
    if (!_isInputDisabled)
      setPaymentTerms(selectedBrandAppendix.paymentterms_id_short_name);
  }, [selectedBrandAppendix]);

  React.useEffect(() => {
    switch (appendixCategory) {
      case "basic":
        setBaseDiscount(
          _get(
            _find(brands, (b) => {
              return selectedBrandAppendix.brand_id === b.id;
            }),
            "basic_discount"
          )
        );
        setShowroomChairs(
          _get(
            _find(brands, (b) => {
              return selectedBrandAppendix.brand_id === b.id;
            }),
            "basic_chair"
          )
        );
        break;
      case "priority":
        setBaseDiscount(
          _get(
            _find(brands, (b) => {
              return selectedBrandAppendix.brand_id === b.id;
            }),
            "priority_discount"
          )
        );
        setShowroomChairs(
          _get(
            _find(brands, (b) => {
              return selectedBrandAppendix.brand_id === b.id;
            }),
            "priority_chair"
          )
        );
        break;
      case "priority":
        setBaseDiscount(
          _get(
            _find(brands, (b) => {
              return selectedBrandAppendix.brand_id === b.id;
            }),
            "preferred_discount"
          )
        );
        setShowroomChairs(
          _get(
            _find(brands, (b) => {
              return selectedBrandAppendix.brand_id === b.id;
            }),
            "preferred_chair"
          )
        );
        break;
      default:
        setBaseDiscount(selectedBrandAppendix.base_discount);
        setShowroomChairs(
          _get(
            _find(brands, (b) => {
              return selectedBrandAppendix.brand_id === b.id;
            }),
            "basic_chair"
          )
        );
        break;
    }
  }, [
    selectedBrandAppendix,
    appendixCategory,
    selectedBrandAppendix.basic_discount,
    selectedBrandAppendix.preferred_discount,
    selectedBrandAppendix.priority_discount,
  ]);

  React.useEffect(() => {}, [validationResult]);
  const handleCategoryChange = (event) => {
    setAppendixCategory(event.target.value);
  };
  const handleDiscountChange = (id, value) => {
    setDiscounts(
      discounts.map((d) => {
        if (d.performance_id === id) d.value = Number(value);

        return d;
      })
    );
  };

  const handleSpecialTerms = (event) => {
    setSpecialTerms(event.target.value);
  };

  const handlePaymentTerms = (event) => {
    setPaymentTerms(event.target.value);
  };

  const handleApprovalMessage = (event) => {
    setApprovalMessage(event.target.value);
  };
  const handleRevenueChange = (year, v) => {
    // console.log(year, v);
    let _re = revenues.map((r) => {
      if (r.year === year) r.target = Number(v.value);
      return r;
    });
    // console.log(_re);
    setRevenues(_re);
  };

  const validateData = async () => {
    let errorElementIdentifiers = {};
    selectedBrandAppendix.revenue.map((r) => {
      if (r.year >= new Date().getFullYear() && !r.target) {
        _set(errorElementIdentifiers, "revenue_" + r.year, ["required"]);
      }
    });
    setValidationResult(errorElementIdentifiers);
    console.log(errorElementIdentifiers, {} === errorElementIdentifiers);
    if (Object.keys(errorElementIdentifiers).length > 0) return false;
    else return true;
  };

  const handleSave = async (redirectFlag = true) => {
    let isDataValid = await validateData();
    console.log("isDataValid", isDataValid);
    if (isDataValid) {
      let updatePayload = {
        contract_id: selectedContract.contract_id,
        brand_id: selectedBrandAppendix.brand_id,
        appendix_category: appendixCategory,
        discounts,
        revenues,
        appendix_base_discount: baseDiscount,
        showroom_chairs: showroomChairs || "",
        special_terms: specialTerms || "",
        paymentterms_id:
          _get(
            _find(paymentDetails, (p) => {
              return paymentTerms === p.name;
            }),
            "id"
          ) || "",
        // paymentterms_id: selectedBrandAppendix.paymentterms_id,
        appendix_id: selectedBrandAppendix.id,
        appendix_status: selectedBrandAppendix.status,
      };
      console.log(updatePayload);
      let result = await postContractAppendix(updatePayload);
      console.log(result);
      switchDataRefreshOn();
      if (redirectFlag) {
        await showSnackbar({
          message: `${t("system.app.flokk.appendix_saved")}`,
          navTo: selectedContract.brands.length > 1 ? "" : "/contracts",
        });
      }
      return true;
    } else {
      return false;
    }

    //history.push("/contracts");
  };

  const handleSubmit = async () => {
    let saveResult = await handleSave(false);
    if (saveResult) {
      let approvalPayload = {
        appendix_id: selectedBrandAppendix.id,
      };
      let result = await submitAppendixForApproval(approvalPayload);
      console.log(result);
      switchDataRefreshOn();
      await showSnackbar({
        message: `${t("system.app.flokk.appendix_sent")}`,
        navTo: selectedContract.brands.length > 1 ? "" : "/contracts",
      });
      //history.push("/contracts");
      return true;
    } else {
      return false;
    }
  };

  const handleAprroval = async (st) => {
    let approvalPayload = {
      appendix_id: selectedBrandAppendix.id,
      complaint_message: approvalMessage || "",
    };
    if (st === 0) {
      await rejectAppendix(approvalPayload);
      await showSnackbar({
        message: `${t("system.app.flokk.appendix_rejected")}`,
        navTo: selectedContract.brands.length > 1 ? "" : "/contracts",
      });
    } else if (st === 1) {
      await approveAppendix(approvalPayload);
      await showSnackbar({
        message: `${t("system.app.flokk.appendix_confirmed")}`,
        navTo: selectedContract.brands.length > 1 ? "" : "/contracts",
      });
    } else {
      return;
    }
    switchDataRefreshOn();
  };

  return (
    <div className={classes.root}>
      <section className={classes.section}>
        <div className={classes.item}>
          <Typography variant="subtitle2" gutterBottom>
            {t("newentity.category")}:
          </Typography>

          {!isInputDisabled && (
            <NativeSelect
              className="section1-input"
              value={appendixCategory}
              onChange={handleCategoryChange}
              inputProps={{
                name: "category",
                id: "category",
              }}
              disabled={isInputDisabled}
            >
              <option value="basic">
                {t("flokk_appendix.category.options.basic")}
              </option>
              <option value="priority">
                {t("flokk_appendix.category.options.priority")}
              </option>
              <option value="preferred">
                {t("flokk_appendix.category.options.preferred")}
              </option>
            </NativeSelect>
          )}

          {isInputDisabled && (
            <Typography variant="subtitle2" gutterBottom>
              {appendixCategory === "basic"
                ? `${t("flokk_appendix.category.options.basic")}`
                : appendixCategory === "priority"
                ? `${t("flokk_appendix.category.options.priority")} `
                : `${t("flokk_appendix.category.options.preferred")}`}
            </Typography>
          )}
        </div>

        <Typography variant="subtitle2" gutterBottom>
          {t("flokk_appendix.revenue_target")} :{" "}
        </Typography>

        {selectedBrandAppendix.revenue &&
          selectedBrandAppendix.revenue.map((r) => {
            if (Number(r.year) >= new Date().getFullYear()) {
              return (
                <div className={classes.item} key={r.year + "_revenue"}>
                  <Typography variant="subtitle2">{r.year}:</Typography>

                  {!isInputDisabled && (
                    <span
                      className={classes.spanText}
                      style={{ color: "#4a5568" }}
                    >
                      <NumberFormat
                        className={
                          _get(validationResult, "revenue_" + r.year)
                            ? "section1-input-currency section1-input-currency-required"
                            : "section1-input-currency"
                        }
                        value={_get(
                          _find(revenues, { year: r.year }),
                          "target"
                        )}
                        customInput={Input}
                        inputMode="numeric"
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        decimalScale={0}
                        suffix={" €"}
                        onValueChange={(values) => {
                          handleRevenueChange(r.year, values);
                        }}
                      />
                    </span>
                  )}

                  {isInputDisabled && (
                    <Typography variant="subtitle2" gutterBottom>
                      {r.target &&
                        r.target.toLocaleString("de-DE", {
                          style: "currency",
                          currency: "EUR",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                    </Typography>
                  )}
                </div>
              );
            }

            return null;
          })}

        <Typography variant="subtitle2">
          {t("flokk_appendix.revenue_actual")}
        </Typography>

        {selectedBrandAppendix.revenue &&
          selectedBrandAppendix.revenue.map((r) => {
            if (
              Number(r.year) < new Date().getFullYear() &&
              Number(r.year) !== 2017
            ) {
              return (
                <div className={classes.item} key={r.year + "_revenue"}>
                  <Typography variant="subtitle2">{r.year}:</Typography>

                  {!isInputDisabled && (
                    <span
                      className={classes.spanText}
                      style={{ color: "#4a5568" }}
                    >
                      <NumberFormat
                        className={
                          _get(validationResult, "revenue_" + r.year)
                            ? "section1-input-currency section1-input-currency-required"
                            : "section1-input-currency"
                        }
                        value={_get(
                          _find(revenues, { year: r.year }),
                          "target"
                        )}
                        customInput={Input}
                        inputMode="numeric"
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        decimalScale={0}
                        suffix={" €"}
                        onValueChange={(values) => {
                          handleRevenueChange(r.year, values);
                        }}
                      />
                    </span>
                  )}

                  {isInputDisabled && (
                    <Typography variant="subtitle2" gutterBottom>
                      {r.actual &&
                        r.actual.toLocaleString("de-DE", {
                          style: "currency",
                          currency: "EUR",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                    </Typography>
                  )}
                </div>
              );
            }
          })}
      </section>

      <section className={classes.section}>
        <Table style={{ backgroundColor: "#ffffff" }} size="small">
          <TableHead></TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <label htmlFor="" className="labels">
                  {t("flokk_appendix.base_discount")}
                </label>
              </TableCell>
              <TableCell style={{ textAlign: "right", paddingRight: "2.4rem" }}>
                {(baseDiscount * 100).toFixed(0) + "%"}
              </TableCell>
            </TableRow>
            {discounts &&
              discounts.map((d, idx) => {
                return (
                  <TableRow
                    key={idx}
                    hover
                    style={{ cursor: "pointer" }}
                    className={classes.head}
                  >
                    <TableCell>
                      <label htmlFor="" className="labels">
                        {d.display_name}
                      </label>
                    </TableCell>
                    {!isInputDisabled && (
                      <TableCell align="right">
                        <NativeSelect
                          className="discount-value"
                          value={d.value || ""}
                          onChange={(event) => {
                            handleDiscountChange(
                              d.performance_id,
                              event.target.value
                            );
                          }}
                          inputProps={{
                            name: "discount" + d.performance_id,
                            id: "discount" + d.performance_id,
                          }}
                          disabled={isInputDisabled}
                        >
                          {d.options.split(",").map((o) => (
                            <option key={o} value={Number(o)}>
                              {Number(o) * 100 + "%"}
                            </option>
                          ))}
                        </NativeSelect>
                      </TableCell>
                    )}
                    {isInputDisabled && (
                      <TableCell
                        style={{
                          textAlign: "right",
                          paddingRight: "2.4rem",
                        }}
                      >
                        {Number(d.value) * 100 + "%"}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            <TableRow>
              <TableCell style={{ fontWeight: 600 }}>
                {t("flokk_appendix.total_discount")}
              </TableCell>
              <TableCell
                style={{
                  textAlign: "right",
                  fontWeight: 600,
                  paddingRight: "2.4rem",
                }}
              >
                {(
                  (baseDiscount +
                    _sumBy(discounts, (d) => {
                      return Number(d.value);
                    })) *
                  100
                ).toFixed(0) + "%"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </section>

      <section className={classes.section}>
        <label htmlFor="" className="labels">
          {t("flokk_appendix.showroom_chairs")}
        </label>
        <Typography variant="subtitle2" className={classes.section3Text}>
          {showroomChairs}
        </Typography>

        <div
          style={{ display: "flex", flexDirection: "column", marginBottom: 8 }}
        >
          <label htmlFor="" className="labels">
            {t("flokk_appendix.payment_terms")}
          </label>
          {!isInputDisabled && (
            <NativeSelect
              value={paymentTerms}
              onChange={handlePaymentTerms}
              inputProps={{
                name: "paymentTerms",
                id: "paymentTerms",
              }}
              disabled={isInputDisabled}
            >
              {paymentDetails.length > 0 &&
                paymentDetails.map((p) => {
                  return (
                    <option key={p.id} value={p.name}>
                      {p.name}
                    </option>
                  );
                })}
            </NativeSelect>
          )}
          {isInputDisabled && (
            <Typography variant="subtitle2" className={classes.section3Text}>
              {paymentTerms}
            </Typography>
          )}
        </div>

        <label htmlFor="" className="labels">
          {t("flokk_appendix.special_terms")}
        </label>
        {!isInputDisabled && (
          <textarea
            rows="2"
            key={selectedBrandAppendix.id}
            className="text-input"
            maxLength="800"
            value={specialTerms || ""}
            onChange={handleSpecialTerms}
            disabled={isInputDisabled}
          />
        )}
        {isInputDisabled && (
          <Typography variant="subtitle2" className={classes.section3Text}>
            {specialTerms}
          </Typography>
        )}

        {!(selectedBrandAppendix.teamlead_id === user.currentUser.id) && (
          <div style={{ fontWeight: "600", marginTop: "1%" }}>
            <label htmlFor="" className="labels">
              {/* Nachricht von RL: */}
              {t("flokk_appendix.complaint_message")}
            </label>
            <Typography
              variant="subtitle2"
              className={classes.section3Text}
              style={{ fontWeight: "600" }}
            >
              {selectedBrandAppendix.complaint_message}
            </Typography>
          </div>
        )}
        {selectedBrandAppendix.teamlead_id === user.currentUser.id &&
          selectedBrandAppendix.status === "negotiated" && (
            <div style={{ fontWeight: "600", marginTop: "1%" }}>
              <label htmlFor="" className="labels">
                Nachricht an GVL:
              </label>
              <textarea
                rows="1"
                maxLength="1000"
                className="text-input"
                onChange={handleApprovalMessage}
              />
            </div>
          )}

        {selectedBrandAppendix.teamlead_id === user.currentUser.id &&
          selectedBrandAppendix.status !== "negotiated" && (
            <div style={{ fontWeight: "600", marginTop: "1%" }}>
              <label htmlFor="" className="labels">
                Nachricht an GVL:
              </label>
              <Typography
                variant="subtitle2"
                className={classes.section3Text}
                style={{ fontWeight: "600" }}
              >
                {selectedBrandAppendix.complaint_message}
              </Typography>
            </div>
          )}

        <div className={classes.buttonSection}>
          {!isInputDisabled &&
            (selectedBrandAppendix.status === "initial" ||
              selectedBrandAppendix.status === "rejected") && (
              <Button
                className={classes.button}
                variant="contained"
                style={{ borderRadius: 0 }}
                onClick={handleSave}
              >
                {t("system.save_btn")}
              </Button>
            )}
          {!isInputDisabled &&
            (selectedBrandAppendix.status === "initial" ||
              selectedBrandAppendix.status === "rejected") && (
              <Button
                className={classes.button}
                variant="contained"
                style={{ borderRadius: 0 }}
                onClick={handleSubmit}
              >
                An RL Senden
              </Button>
            )}

          {selectedBrandAppendix.teamlead_id === user.currentUser.id &&
            selectedBrandAppendix.status === "negotiated" && (
              <Button
                className={classes.button}
                variant="contained"
                style={{ borderRadius: 0 }}
                onClick={() => {
                  handleAprroval(1);
                }}
              >
                Genehmigen
              </Button>
            )}
          {selectedBrandAppendix.teamlead_id === user.currentUser.id &&
            selectedBrandAppendix.status === "negotiated" && (
              <Button
                className={classes.button}
                variant="contained"
                style={{ borderRadius: 0 }}
                onClick={() => {
                  handleAprroval(0);
                }}
              >
                Ablehnen
              </Button>
            )}
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectedContract: selectedContract,
  payment_terms: payment_terms,
  brand_details: brand_details,
});

const mapDispatchToProps = (dispatch) => ({
  showSnackbar: (message) => dispatch(showSnackbar(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandAppendix);
